(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
     

$(function() {
  var $iframe = $('.gu-article__content').find('iframe');

  $iframe.each(function(){
	var $this = $(this);
	var isPortrait = $this.hasClass('v-portrait');
	var $iframeClone = $this.clone(false);
	var classer = (isPortrait) ? 'videoWrapperPort' : 'videoWrapper' ;
  	var $iframeHome = $('<div />').addClass(classer);
  	$iframeHome.append($iframeClone);
  	$iframeHome.insertBefore($this); 
  	$this.remove(); 
  });
  

  var $lookbook = $('.gu-lookbook');
  var $article = $('.gu-article');
  var $newBook = $('<div />').addClass('gu-lookbook-display');

  if($lookbook.length) {
    var $images = $lookbook.find('img'); 
    // console.log('images');
    // console.log($images); 

    $images.each(function(index){
      var $this = $(this);
      var src = $this.attr('src'); 
      var newsrc = src.replace('_1024x1024', '_520x520_crop_center');
      $this.attr('src', newsrc + '01');   
      // console.log('newsrc: ' + newsrc + '01'); 
      $newBook.append($this);
    }); 
  } else {
    console.log('no book');

  }
  $newBook.insertAfter($article);
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    

$(".gu-cart__change").change(function() { 
  $('.gu-cart__update-button').removeClass('gu-disabled');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filters"]) return;
  try {
    
  
  var collectionFilters = current_tags || []; 
  $filterItem = $('.gu-filters__item');
  $filterItem.each(function(){
    var $this = $(this);
    var filterVal = $this.attr('data-val');
    if(collectionFilters.includes(filterVal)) {
      $this.addClass('active'); 
    }
  })

  $filterItem.on('click', function(){
    var $this = $(this);
    var filterVal = $this.attr('data-val');
    $this.toggleClass('active');
    if(!collectionFilters.includes(filterVal)) {
      collectionFilters.push(filterVal);
    } else {
      collectionFilters = collectionFilters.filter(e => e !== filterVal);
    }
  });

  var $closeFilters = $('.js-close-filters');
  $closeFilters.on('click', function(){
    $('body').removeClass('filters-open'); 
  });



  var $filterCollection = $('.js-filter-items'); 
  $filterCollection.on('click', function(){
    window.location.href = collectionUrl + '/' + collectionFilters.join('+');
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-button"]) return;
  try {
    

  $(function() {
    var $gu_floatyBtn = $('.gu-floating-btn');
    var scrollTimer = null;

    $gu_floatyBtn.on('click', function(){
      var whereTo = $('.gu-product__data').position().top
      // console.log('whereTo: ' + whereTo);
      $('.gu-canvas').animate({
        scrollTop: whereTo
      }, 500);
    });
 
    function checkFloater() {
      var $checkElem = $('.gu-product__action'); 
      var top_of_element = $checkElem.offset().top;
      var bottom_of_element = $checkElem.offset().top + $checkElem.outerHeight();
      var winH = $(window).innerHeight();
  
      if ((top_of_element < winH) && (bottom_of_element > 0)){
        $gu_floatyBtn.addClass('hide');
      } else {
        $gu_floatyBtn.removeClass('hide');
      }
    } 
    
    $('.gu-canvas').scroll(function(){
      checkFloater()
    });

    checkFloater();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    


// console.log('setInterval(checkinsta, 1000)');
var checkForInstagram = setInterval(checkinsta, 1000);

function checkinsta() {
  var $instaTitle = $('#insta-feed h2');
  if($instaTitle.length) {
    stopCheckForInstagram();
    var title  = $instaTitle.html();
    $instaTitle.html(title.replace('@GEEDUPCO', '<span>@GEEDUPCO</span>'));
  } 
}

function stopCheckForInstagram() {
  clearInterval(checkForInstagram);
} 
  /*
  $('.gu-collection__item-carousel').flickity({
    // options
    cellAlign: 'center',
    lazyLoad: true,
    wrapAround: true,
    prevNextButtons: false,
    contain: true,
    cellSelector: '.gu-collection__item-image-link'
  });
  */

  var collectionCarousels = document.querySelectorAll('.gu-collection__item-carousel');
  for ( var i=0, len = collectionCarousels.length; i < len; i++ ) {
    var galleryElem = collectionCarousels[i];
    new Flickity( galleryElem, {
      cellAlign: 'center',
      lazyLoad: true,
      wrapAround: true,
      prevNextButtons: false,
      contain: true,
      cellSelector: '.gu-collection__item-image-link'
    });
  }


/*
$(function() {
  
  if($instaTitle.length) {
    // console.log('setTimeout');
    setTimeout(changeInstaTitle, 3000);
  }
});

function changeInstaTitle() {
  var $instaTitleh2 = $instaTitle.find('h2')
  var instaTitleContent = $instaTitleh2.html()
  newInstaTitleContent = instaTitleContent.replace('@geedupco', '<span>@geedupco</span>');
  $instaTitleh2.html(newInstaTitleContent);
}
*/

  // Accordion - Container
  var $guAccordion = $('dl.gu-accordion');
  if($guAccordion) {
    $guAccordion.find('.gu-accordion__data').slideUp();

    $guAccordion.on('click', '.gu-accordion__term:not(.active)', function(){
      $guAccordion.find('.gu-accordion__term.active').removeClass('active');
      $guAccordion.find('.gu-accordion__data').slideUp();
      $(this).addClass('active').next('.gu-accordion__data').slideDown();
    });

    $guAccordion.on('click', '.gu-accordion__term.active', function(){
      $(this).removeClass('active').next('.gu-accordion__data').slideUp();
    });
  }

  // Accordion - Container
  var $guSubAccordion = $('dl.gu-sub-accordion');
  if($guSubAccordion) {
    $guSubAccordion.find('.gu-sub-accordion__data').slideUp();

    $guSubAccordion.on('click', '.gu-sub-accordion__term:not(.active)', function(){
      $guSubAccordion.find('.gu-sub-accordion__term.active').removeClass('active');
      $guSubAccordion.find('.gu-sub-accordion__data').slideUp();
      $(this).addClass('active').next('.gu-sub-accordion__data').slideDown();
    });

    $guSubAccordion.on('click', '.gu-sub-accordion__term.active', function(){
      $(this).removeClass('active').next('.gu-sub-accordion__data').slideUp();
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-promo-tracksuits"] && !Shopify.designMode) return;
  try {
    

var $promo_close = $('.js-close-promo-modal');
 
$promo_close.click(function(){
  $('body').removeClass('gu-promo-open');
});

window.checkPromo = function(id) {
  // console.log('CHECKING PROMO: ' + id);
  if(id === 6574715633743 || id === '6574715633743') {
    // console.log('PROMO TRIGGERED');
    $('body').addClass('gu-promo-open'); 
  }
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-suggest"] && !Shopify.designMode) return;
  try {
    

var suggestedID = undefined;
function suggestItem(id) {
  window.quickAdd(suggestedID, 'suggest', 0);
}

window.checkSuggest = function(id) {
  console.log('CHECKING: ' + id);
  window.closeQuickAdd();
  var hasSuggest = window.quickadd[id];
  if(hasSuggest != undefined) {
    suggestedID = id;
    window.setTimeout(suggestItem, 500); 
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    


var sideBarActive = false;
var $body =  $('body');
var $gu_canvas =  $('.gu-canvas');
var hasScrollbar = $gu_canvas.width() < $body.width();

function is_colliding( $div1, $div2 ) {
	// Div 1 data
	var d1_offset             = $div1.offset();
	var d1_height             = $div1.outerHeight( true );
	var d1_width              = $div1.outerWidth( true );
	var d1_distance_from_top  = d1_offset.top + d1_height;
	var d1_distance_from_left = d1_offset.left + d1_width;

	// Div 2 data
	var d2_offset             = $div2.offset();
	var d2_height             = $div2.outerHeight( true );
	var d2_width              = $div2.outerWidth( true );
	var d2_distance_from_top  = d2_offset.top + d2_height;
	var d2_distance_from_left = d2_offset.left + d2_width;

	var not_colliding = ( d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left );

	// Return whether it IS colliding
	return ! not_colliding;
};
window.checkInvert = function($logo, $invert){
  var collision = false ;
    $invert.each(function(){
      var $this = $(this);
      collision = is_colliding($logo, $this);

      if(collision) {
        $body.removeClass('gu-invert');
        return false;
      } else {
        $body.addClass('gu-invert');
      }
    })
}

$(document).ready(function() {
  if (window.location.href.indexOf("returns") > -1) {
    $body.removeClass('gu-invert');
  }
});

jQuery(function($){
  var $logo = $('.gu-header__logo');
  var $invert = $('.gu-inverter');
  window.checkInvert($logo, $invert);
  $('#page-content').scroll(function(){
    window.checkInvert($logo, $invert);
  });
 });

if(hasScrollbar) {
  $body.addClass('scrollbars');
} 

var showSideBar = () => {
  sideBarActive = true;
  var scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  var body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
  body.style.width = `100vw`;
};

var closeSideBar = () => {
  sideBarActive = false;
  var body = document.body;
  var scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  body.style.width = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});


$('.gu-prevent-clicks').click(function(ev){ 
  $body.removeClass('search-open cart-open nav-open filters-open buy-all-open');
});

$('.js-filter-toggle').click(function(){
  $body.addClass('filters-open');
});

$('.js-search-toggle').click(function(){
  $body.removeClass('cart-open nav-open filters-open buy-all-open');

  if($body.hasClass('search-open')) {
    $body.removeClass('search-open');
  } else {
    $body.addClass('search-open ');
    $('.gu-site-search__input').focus();
  }
});


$('.js-menu-toggle').click(function(){
  $body.removeClass('search-open cart-open filters-open buy-all-open');

  if($body.hasClass('nav-open')) {
    $body.removeClass('nav-open');
  } else {
    $body.addClass('nav-open');
  }
});

$('.js-cart-toggle').click(function(ev){
  ev.preventDefault();
  $body.removeClass('search-open nav-open filters-open buy-all-open');
  
  if ($body.hasClass('cart-open')) {
    $body.removeClass('cart-open');
  } else {
    $body.addClass('cart-open');
  }
});


function showStatus(success) {
  if(success) {
    $('.gu-header__bag').addClass('bag-success');
    setTimeout(hideStatus, 2000);
  }
}
function hideStatus() {
  $('.gu-header__bag').removeClass('bag-success');
}

window.setCartCount = function(increment, variant_id, product){
  var count = window.cartCount + increment;
  // console.log('product')
  // console.log(product)
  $('.gu-header__bag-count').html(count);
  window.cartCount = count;
  showStatus(true);
}

window.refreshCartCount = function(count){
  $('.gu-header__bag-count').html(count);
  window.cartCount = count;
}

window.checkPromoOnCheckout = function() {
  if(window.beerPromoEnabled) {
    window.beerPromoCheckout();
  } else {
    console.log('no promo');
    window.location.replace('/checkout/');
  }
} 
window.checkPromoOnAdd = function(id) {
  // console.log('CHECKING PROMO: ' + id);
  if(window.beerPromoEnabled) {
    window.beerPromoAdd(); 
  }
  // if(id === 6574715633743 || id === '6574715633743') {
  //  console.log('PROMO TRIGGERED');
  //  $('body').addClass('gu-promo-open'); 
  //}
}
window.checkPromoOnCartChange = function(item_count, total) {
  if(window.beerPromoEnabled) {
    window.checkBeerOnCartChange(item_count);
  }
  window.cartPromo(total);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".gu-product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".gu-product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

  var $body = $('body');

  var selectedVariant = false;
  var selectedProduct = false;
  var $gu_variants = $('.gu-product__variants');
  var $p_action = $('.gu-product__action');

  var $qty_minus = $('.gu-product__quantity-button--minus');
  var $qty_plus = $('.gu-product__quantity-button--plus');
  var $qty_value = $('.gu-product__quantity-value');
  var qty = 1;
  var maxQty = 30;

  function updateQty() {
    $qty_value.html(qty);
    if(qty > 1 && qty < maxQty ) {
      $qty_minus.removeClass('q-disabled');
      $qty_plus.removeClass('q-disabled');
    } 

    if(qty == maxQty ) {
      $qty_plus.addClass('q-disabled');
    } 

    if(qty == 1 ) {
      $qty_minus.addClass('q-disabled');
    } 
  }

  $qty_minus.click(function(){
    $qty_minus.blur();
    if(qty > 1) {
      qty--;
      updateQty();
    }
  });

  $qty_plus.click(function(){
    $qty_plus.blur();
    if(qty < maxQty) {
      qty++;
      updateQty();
    }
  });

  $p_action.click(function(){
    var $this = $(this); 
    $this.addClass('p-loading');

    if(selectedVariant) {   
      jQuery.post('/cart/add.js', {   
        quantity: qty, 
        id: selectedVariant  
      }, function(data){
        window.checkSuggest(data.product_id);
        window.checkPromoOnAdd(data.product_id);

        window.setCartCount(qty, selectedVariant, selectedProduct);
        $this.removeClass('p-loading').addClass('c-disabled');
        $gu_variants.find('.v-selected').removeClass('v-selected');
 
        selectedVariant = false;
        qty = 1;
        updateQty();
        window.refreshCart(); 
        window.openCart();  
      },'json');
    }
  });
  
  $(function() {
 
    /*
    $('.gu-product__images').flickity({
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: false, 
      lazyLoad: 2,
      pageDots: false 
    });
    */

    window.productFlickity = new Flickity( '.gu-product__images', {
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: false, 
      lazyLoad: 2,
      pageDots: false 
    });


    $('.gu-product__variant').click(function(){
      var $this = $(this);
      $gu_variants.find('.v-selected').removeClass('v-selected');
      $('.c-disabled').removeClass('c-disabled');
      $this.addClass('v-selected');
      selectedVariant = $this.data('id');
      //lowstock notification
      var inventoryqty = $(this).data('inventory');
      if(inventoryqty < 10){
        $('.lowstock-info').text('Only ' + inventoryqty + ' Pieces Left');
        $('.inventoryNote').show();
      }
      else if(inventoryqty < 50){
        $('.lowstock-info').text('Low On Stock');
        $('.inventoryNote').show();
      }
      else{
        $('.inventoryNote').hide();
      }
    })

    // Accordion - Container
    var $listContainer = $('dl.gu-product__accordion');
    $listContainer.find('dd').slideUp();

    $listContainer.on('click', 'dt:not(.active)', function(){
      $listContainer.find('dt.active').removeClass('active');
      $listContainer.find('dd').slideUp();
      $(this).addClass('active').next('dd').slideDown();
    });

    $listContainer.on('click', 'dt.active', function(){
      $(this).removeClass('active').next('dd').slideUp();
    });

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-add-all"]) return;
  try {
    

  var $body = $('body');
  var $sizes = $('.gu-quick-add-all__size');
  var $buttons = $('.gu-quick-add-all__size-button');
  var $qaa_action = $('.gu-quick-add-all__action');
  var $qaa_close = $('.js-close-quick-add-all');
  var $qaa_caption = $('.gu-quick-add-all__caption span');
  var quickBuyId = false;
  var size_selections = {};

  $(function() {
    $('.js-buy-all').click(function() {
      var $this = $(this);
      var collectionId = $this.attr('data-collection'); 
      var collectionTitle = $this.attr('data-collection-title'); 
      quickBuyId = collectionId;
      $body.addClass('buy-all-open');
      $qaa_caption.html(collectionTitle);
      var types = ['outerwear', 'tops', 'bottoms'];

      if(types.includes(collectionTitle.toLowerCase())) {
        var $sizes = $('.gu-quick-add-all__size');
        $sizes.each(function(){
          var $this = $(this);
          var type = $this.attr('data-type');
          if(collectionTitle.toLowerCase() !== type) {
            $this.addClass('disabled');
            size_selections[type] = false;
            $this.hide();
          }
        })
      }

    });

    $qaa_close.click(function(){
      $body.removeClass('buy-all-open'); 
      $('.failed').removeClass('failed');
    });

    $buttons.click(function(ev){    
      var $this = $(this);
      var size = $this.attr('data-size');
      var type = $this.attr('data-type');
      $('button[data-type="'+type+'"').removeClass('active');
      $this.addClass('active');

      size_selections[type] = size;
      // console.log(size_selections);
      // console.log(Object.keys(size_selections).length);

      if(Object.keys(size_selections).length === 3) {
        $('button.gu-quick-add-all__action').removeClass('qa-disabled');
      }
    });

    $qaa_action.click(function(){
      var $this = $(this);
      var action = $this.attr('data-action');
      var itemsToAdd = [];
      var types = ['outerwear', 'tops', 'bottoms'];
      
      for (const item of window.quickadd[quickBuyId]) {
        if(!item.title.toLowerCase().includes('gift') && item.available) {
          var tags = item.tags;
          
          if(item.variants.length === 1) {
            itemsToAdd.push(
              {
                quantity: 1,
                id: item.variants[0].id
              }
            )
          } else {
            // console.log(tags);

            var targetType = false;

            for (t in tags) {
              var tag = tags[t];
              if(types.includes(tag.toLowerCase())) {
                targetType = tag.toLowerCase();
              }
              
            }
            if (targetType !== false) {
              // console.log(`Target Type = ${targetType}`);
              for (i in item.variants) {
                var variant = item.variants[i];
                var vTitle = variant.title.toLowerCase().replace(/ *\([^)]*\) */g, "");
                if(vTitle === size_selections[targetType]) {
                  if(variant.available) {
                    itemsToAdd.push(
                      {
                        quantity: 1,
                        id: variant.id
                      }
                    )
                  }
                }
              }
            }

          } 
        }
      }

      const data = {
        items: itemsToAdd
      };

      $this.addClass('qaa-loading');
      if(Object.keys(size_selections).length === 3) {
        jQuery.post('/cart/add.js', data , function(data){
          window.setCartCount(itemsToAdd.length, false, false);
          if(action == 'checkout') {
            window.checkPromoOnCheckout(); 
            $body.removeClass('buy-all-open'); 
          } else {
            $('body').removeClass('gu-promo-open'); 
            window.checkPromoOnAdd('');
            $body.removeClass('buy-all-open'); 
            $buttons.removeClass('active');
            $qaa_caption.html('');
          }
          window.refreshCart(); 
        },'json')
        .done( function(msg) {
          console.log('WORKED'); 
          console.log(msg);
        })
        .fail(function(xhr, status, error) {
          $('.gu-quick-add-all').addClass('failed');
        });
      }
    
    });
  


  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-add"]) return;
  try {
    

  var $body = $('body');
  var $qa = $('.gu-quick-add');
  var $qa_container = $qa.find('.gu-quick-add__container');
  var $qa_title = $qa.find('.gu-quick-add__title');
  var $qa_price = $qa.find('.gu-quick-add__price');
  var $qa_images = $qa.find('.gu-quick-add__images');
  var $qa_action = $qa.find('.gu-quick-add__action');
  var $qa_variants = $qa.find('.gu-quick-add__variants');
  var $qa_variant = $qa.find('.gu-quick-add__variant');
  var $qa_close = $qa.find('.js-close-quick-add');
  window.selectedVariant = false;
  window.selectedProduct = false;
  window.selectedId = false;
  

  window.closeQuickAdd = function() {
    // console.log('closing QA')
    var $body = $('body');
    var $qa = $('.gu-quick-add');
    var $qa_container = $qa.find('.gu-quick-add__container');
    var $qa_title = $qa.find('.gu-quick-add__title');
    var $qa_price = $qa.find('.gu-quick-add__price');
    var $qa_variants = $qa.find('.gu-quick-add__variants');
    $qa_container.removeClass('suggested');

    $body.removeClass('quick-add-open');
    $qa_title.html('');
    $qa_price.html('');
    $qa_variants.html(''); 
    $('.qa-loading').removeClass('qa-loading');
    if(window.qaFlkty !== undefined) {
      window.qaFlkty.destroy();   
    } 
    window.selectedVariant = false;
    window.selectedProduct = false; 
    window.selectedId = false;
  }
  // console.log('window.cartCount: ' + window.cartCount);

  window.quickAdd = function(collection, product_id, index) {
    // console.log('product_idpp');  
    // console.log(product_id);
    if( product_id === 6574715633743 ){
      // console.log('found');  
      $('button[data-action="checkout"]').hide(); 
    } else {
      $('button[data-action="checkout"]').show();
    }
    var suggested = (product_id == 'suggest') ? true : false;
    var product = window.quickadd[collection][index];
    var $body = $('body');
    var $qa = $('.gu-quick-add')
    var $qa_container = $qa.find('.gu-quick-add__container');
    var $qa_title = $qa.find('.gu-quick-add__title');
    var $qa_price = $qa.find('.gu-quick-add__price');
    var $qa_images = $qa.find('.gu-quick-add__images');
    var $qa_action = $qa.find('.gu-quick-add__action');
    var $qa_variants = $qa.find('.gu-quick-add__variants');
    var $qa_variant = $qa.find('.gu-quick-add__variant');
    var $qa_close = $qa.find('.js-close-quick-add');
    window.selectedVariant = false;
    window.selectedProduct = false;

    if(suggested) {
      $qa_container.addClass('suggested');
    }

    $qa_images.html('');
    
    window.selectedId = product.id;

    $qa_title.html(product.title); 
    var productPrice = product.price;

    if(!productPrice) {
      productPrice = product.variants[0].price 
    } else { 
      productPrice = product.price / 100;
    }

    if (window.Shopify.currency.active === 'GBP') {
      $qa_price.html( '£' + productPrice + ' GBP');
    } else if (window.Shopify.currency.active === 'NZD') {
      $qa_price.html( '$' + productPrice + ' NZD');
    } else {
      $qa_price.html( '$' + productPrice);
    }

    for (i = 0; i < product.images.length; i++) { 
      var imageURL = product.images[i]; 
      var imageURL = (typeof imageURL === 'object') ? imageURL.src : imageURL;
      if(imageURL.length) {
        var $img = $('<img />').attr('src', window.default_img_square).attr('data-flickity-lazyload', imageURL.replace('.j', '_640x640_crop_center.j').replace('.p', '_640x640_crop_center.p')).addClass('gu-quick-add__image').appendTo($qa_images);
      }
    }
    if(product.variants) {
      for (i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i]; 
        var btn_class = "gu-quick-add__variant"
        btn_class = (variant.available == false) ? btn_class + ' v-disabled'  : btn_class;
        var btn_title = variant.title.replace('(','<span>(').replace(')',')</span>').replace('Default Title','One Size');
        var $button = $('<button />') 
          .html(btn_title)
          .addClass(btn_class)
          .attr('data-id', variant.id)
          .click(function(){
            var $this = $(this);
            $qa_variants.find('.v-selected').removeClass('v-selected');
            $('.qa-disabled').removeClass('qa-disabled');
            $this.addClass('v-selected');
            window.selectedVariant = $this.data('id');
            window.selectedProduct = {
              title: product.title,
              variant: variant.title,
              price: product.price,
              image: product.images[1]
            };
          })
          .appendTo($qa_variants);
      }
    }

    $body.addClass('quick-add-open'); 
    $guqaImages = $('.gu-quick-add__images');
    
    if($guqaImages.length) {
       
      /* 
      $('.gu-quick-add__images').flickity({
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false, 
        lazyLoad: 2
      }); 
      */
      // console.log('QUICK ADDDDSSS');
      window.qaFlkty = new Flickity( '.gu-quick-add__images', {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false, 
        lazyLoad: 2
      });

    }
  }


  
  $(function() {

    $qa_action.click(function(){
      var $this = $(this);
      var action = $this.attr('data-action');
      $this.addClass('qa-loading');

      if(window.selectedVariant) {
        jQuery.post('/cart/add.js', {
          quantity: 1,
          id: window.selectedVariant 
        }, function(data){
          // window.checkSuggest(data.product_id);
          window.setCartCount(1, window.selectedVariant, window.selectedProduct);

          if(action == 'checkout') {
            window.checkPromoOnCheckout(); 
            window.closeQuickAdd();
          } else {
            $('body').removeClass('gu-promo-open'); 
            window.checkPromoOnAdd(data.product_id);
            window.closeQuickAdd();
            window.openCart();
          }
          window.refreshCart(); 
        },'json'); 
      }
    });

    /*$('.js-quick-add').click(function(ev){
      var $this = $(this); 
      var collection = parseInt($this.data('collection'));
      var product = parseInt($this.data('product'));
      var index = parseInt($this.data('index')) - 1;
      window.quickAdd(collection, product, index);
    });*/

    $(document).on('click', '.js-quick-add', function(){
      var $this = $(this); 
      var collection = parseInt($this.data('collection'));
      var product = parseInt($this.data('product'));
      var index = parseInt($this.data('index')) - 1;
      window.quickAdd(collection, product, index);
    });

    $qa_close.click(function(){
      window.closeQuickAdd();
    });

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-cart"]) return;
  try {
    



function increaseCart(itemId, qty) {
  var newQty = parseInt(qty) + 1 ;
  newQty = (newQty > 3) ? 3 : newQty;
  jQuery.post('/cart/change.js', {
    'id': parseInt(itemId), 
    'quantity': newQty
  }, function(data){
    window.refreshCart(); 
  },'json');
}

function decreaseCart(itemId, qty) {
  var newQty = parseInt(qty) - 1 ;
  jQuery.post('/cart/change.js', {
    'id': parseInt(itemId),
    'quantity': newQty
  }, function(data){
    window.refreshCart();
  },'json');
}


function removeCart(itemId) {
  jQuery.post('/cart/change.js', {
    'id': parseInt(itemId), 
    'quantity': 0
  }, function(data){
    window.refreshCart(); 
  },'json');
}

window.refreshCart = function() {
  var $wrapper = $('.gu-side-cart__items')
  jQuery.getJSON('/cart.js', function(cart) {
    // now have access to Shopify cart object
    window.refreshCartCount(cart.item_count);
    var $subTotal = $('.gu-side-cart__subtotal-value');
    var wrapper = $('.gu-side-cart__items');
    var total = cart.total_price;
    var items = cart.items;
    var item_count = cart.item_count;
    var discount = cart.total_discount;
    if (window.Shopify.currency.active === 'GBP') {
      $subTotal.html( '£' + (total / 100).toFixed(2) + ' GBP');
    } else if (window.Shopify.currency.active === 'NZD') {
      $subTotal.html( '$' + (total / 100).toFixed(2) + ' NZD');
    } else {
      $subTotal.html('$' + (total / 100).toFixed(2))
    };
    window.checkPromoOnCartChange(item_count, total);

    // console.log('for item');
    $wrapper.html('');  

    if (window.Shopify.currency.active === 'GBP') {
      $('.gu-cart__subtotal-value').html( '£' + (total / 100).toFixed(2) + ' GBP');
    } else if (window.Shopify.currency.active === 'NZD') {
      $('.gu-cart__subtotal-value').html( '$' + (total / 100).toFixed(2) + ' NZD');
    } else {
      $('.gu-cart__subtotal-value').html( '$' + (total / 100).toFixed(2))
    }
    

    if(items.length){
      for (i in items) { 
        var item = items[i]; 
        if (window.Shopify.currency.active === 'GBP') {
          var priceCalc = '£' + (item.final_line_price / 100).toFixed(2) + ' GBP';
        } else if (window.Shopify.currency.active === 'NZD') {
          var priceCalc = '$' + (item.final_line_price / 100).toFixed(2) + ' NZD';
        } else {
          var priceCalc = '$' + (item.final_line_price / 100).toFixed(2);
        }
        var priceVal = (item.final_line_price > 0) ? priceCalc : 'FREE';
        var newItem = $('<div />').addClass('gu-sc-item').attr('data-item', i);
        var image = $('<img />').addClass('gu-sc-item__image').attr('src', item.featured_image.url.replace('.jpg', '_120x184_crop_center.jpg').replace('.png', '_120x184_crop_center.png')).attr('alt', item.featured_image.alt).appendTo(newItem);
        var data = $('<div />').addClass('gu-sc-item__data').appendTo(newItem);
        var title = $('<div />').addClass('gu-sc-item__title').html(item.product_title).appendTo(data); 
        var meta = $('<div />').addClass('gu-sc-item__meta').appendTo(data); 
        if(item.variant_title){
          var variant = $('<div />').addClass('gu-sc-item__variant').html(item.variant_title.replace('(','<span>(').replace(')',')</span>').replace('Default Title','One Size')).appendTo(meta);
        } else {
          var variant = $('<div />').addClass('gu-sc-item__variant').html('One Size').appendTo(meta); 
        }
        if (window.Shopify.currency.active === 'GBP') {
        var price = $('<div />').addClass('gu-sc-item__price').html( '£' + (item.final_price / 100).toFixed(2) + ' GBP ' + 'ea').appendTo(meta);
        } else if (window.Shopify.currency.active === 'NZD') {
        var price = $('<div />').addClass('gu-sc-item__price').html( '$' + (item.final_price / 100).toFixed(2) + ' NZD ' + 'ea').appendTo(meta);
        } else {
        var price = $('<div />').addClass('gu-sc-item__price').html( '$' + (item.final_price / 100).toFixed(2) + 'ea').appendTo(meta);
        }
        var summary = $('<div />').addClass('gu-sc-item__summary').appendTo(data);
        
          var quantity = $('<div />').addClass('gu-sc-item__quantity').appendTo(summary);
          var reduce = $('<div />').addClass('gu-sc-item__quantity-reduce').html("-").attr('data-variant', item.variant_id).attr('data-qty', item.quantity).appendTo(quantity);
          var qtyVal = $('<div />').addClass('gu-sc-item__quantity-value').html(item.quantity).appendTo(quantity)
          
          var increase = $('<div />').addClass('gu-sc-item__quantity-increase').html('+').attr('data-variant', item.variant_id).attr('data-qty', item.quantity).appendTo(quantity);
          

        var total = $('<div />').addClass('gu-sc-item__total').html(priceVal).appendTo(summary);
        var remove = $('<div />').addClass('gu-sc-item__remove').attr('data-variant', item.variant_id).attr('data-qty', item.quantity).appendTo(newItem);
        var removeA = $('<span />').addClass('gu-sc-item__remove-part gu-sc-item__remove-part--1').appendTo(remove);
        var removeB = $('<span />').addClass('gu-sc-item__remove-part gu-sc-item__remove-part--2').appendTo(remove);
         
        if (item.quantity == 3) {
          increase.addClass('sc-disabled');
        }

        increase.click(function(){ 
          var $this = $(this);
          $('body').addClass('cart-updating');
          increaseCart($this.attr('data-variant'), $this.attr('data-qty'));
        });

        reduce.click(function(){
          var $this = $(this);
          $('body').addClass('cart-updating');
          decreaseCart($this.attr('data-variant'), $this.attr('data-qty'));
        });

        remove.click(function(){
          var $this = $(this);
          $('body').addClass('cart-updating');
          removeCart($this.attr('data-variant'), $this.attr('data-qty'));
        });

        if(item.sku.includes("V-")) { 
          reduce.remove();   
          increase.remove();   
        } 

        if(priceCalc == 0) {
          quantity.remove()
          price.remove();
          remove.remove();
        }

        newItem.appendTo($wrapper);
      }
    } else {
      var newItem = $('<div />').addClass('gu-sc-item__empty').html('<strong>Cart is empty</strong>');
      newItem.appendTo($wrapper);
    }

    $('body').removeClass('cart-updating');
 
  });
}

window.refreshCart();


$(".gu-side-cart__action").click(function(e){
  e.preventDefault();
  $('body').removeClass('search-open nav-open filters-open buy-all-open cart-open');
  // console.log('stopping checkout for promo');
  window.checkPromoOnCheckout();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-search-modal"]) return;
  try {
    

  var $body = $('body');
  var $ss = $('.gu-site-search')
  var $ss_container = $ss.find('.gu-site-search__container');

  $ss_container.click(function(e){
    if( e.target !== this) return;
    $body.removeClass('search-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    

  jQuery(function() {
    var elem = document.querySelector('.gu-carousel');
	if(elem !== null){
      var flkty = new Flickity( elem, {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false,
        lazyLoad: 2
      });
	}
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault"]) return;
  try {
    

$(document).on('click', '.gu-vault-landing__link', function (event) {
    event.preventDefault();

    $('.gu-canvas').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});

history.replaceState(null, null, ' ');


/* FILTER
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ 

function filterProducts(val) {
  if(val !== '') {
    $('.gu-vault__product').each(function(){
      var $this = $(this);
      var theTag = $this.data('tag');
      if(theTag == val) {
        $this.css({'display': 'block'}).animate({'opacity': 1}, 300);
      } else {
        $this.hide();
      }
    })
  } else {
    $('.gu-vault__product')
      .css({'display': 'block'})
      .animate({'opacity': 1}, 300);
  }
}

$('.select-css').on('change', function(){
  var $this = $(this);
  var thisVal = $this.val();
  // console.log('thisVal: '+thisVal);
    $('.gu-vault__product').animate({'opacity': 0}, 300, function(){
      filterProducts(thisVal);
    });

});

/* VARIABLES
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ 
var $body = $('body');
var $inputs = $('.gu-vault-code__input');
var $vaultCollection = $('.gu-vault-collection');
var $vaultCollectionItems = $vaultCollection.find('.gu-vault-collection__items');
var $vaultLanding = $('.gu-vault-landing');
var $landingButton = $('.gu-vault-landing__button');
var $landingButtonVIP = $('.gu-vault-landing__button-vip');
var $accessForm = $("#vaultCheck");
var $vaultGate = $('.gu-vault-gate');
var $errorMessage = $('.gu-vault-gate__error');
var allowed = false;
var disabled = false;
var timerEnabled = false;

var $logo = $('.gu-header__logo');
var $invert = $('.gu-inverter');
var collectionItems = [];
window.checkInvert($logo, $invert);

/* ACTIONS
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ 

 disableInputs();

 $landingButton.on('click', function(){
  $vaultGate.addClass('gu-vault-gate--show');
  clearInputVals();
  enableInputs();
  setTimeout(function(){
    $inputs[0].focus();
  }, 1000);
});

$landingButtonVIP.on('click', function(){
  var id = $landingButtonVIP.attr('id');
  var name = $landingButtonVIP.attr('data-name');
  $vaultGate.addClass('gu-vault-gate--show');
  fillVIPInputs('-VAULTVIP-');
  vipAccess(id, name);
});
 
$inputs.on('paste', function(e) {
  if(!disabled) {
    var pastedData = e.originalEvent.clipboardData.getData('Text');
    fillInputs(pastedData);
  }
});

$inputs.on('keyup', function(e) {
  var $this = $(this);
  var thisVal = $this.val();

  var isWordCharacter = event.key.length === 1;
  var isBackspaceOrDelete = event.keyCode === 8 || event.keyCode === 46;

  if (isWordCharacter || isBackspaceOrDelete) {
    if(thisVal != '') {
      $this.next('input').focus();
    } else {
      $this.prev('input').focus().select();
    }
    checkInputVals();
  }
});

$accessForm.submit(function(e) {
  e.preventDefault(); // avoid to execute the actual submit of the form.
});


/* FUNCTIONS
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

function populateVault(collection) { 
  var collectionID = 90000000900000009;
  $vaultGate.removeClass('code-accepted');
  $vaultGate.removeClass('gu-vault-gate--show').addClass('gu-vault-gate--hide');
  hideGate();
  $vaultLanding.addClass('show-collection');
	$('.gu-vault-exp').hide();
  window.quickadd[collectionID] = collection;
  collectionItems = collection;

  vtags = [ 
    ['', ''],
    ['exclusive', 'VAULT EXCLUSIVE'],
    ['one-off', 'ONE OFF'],
    ['restock', 'SURPLUS STOCK'],
    ['surplus-stock', 'SURPLUS STOCK'], 
    ['made-to-order', 'MADE TO ORDER'] 
  ];

  var $productTag = $('<div />').addClass('vault-tag');

  for (x in collection) {
    var productData = collection[x];
    if(productData.status != 'active') {
      continue; 
    }
 
    // console.log('productData'); 
    // console.log(productData);

    var vaultDataTag = 0;
    if(productData.tags.includes("exclusive")) {
      vaultDataTag = 1;
    }
    if(productData.tags.includes("one-off")) {
      vaultDataTag = 2;
    }
    if(productData.tags.includes("restock")) {
      vaultDataTag = 3;
    }
    var delay = 200 * x;
    var $newProduct = $('<div />')
      .addClass('gu-vault__product')
      .attr('data-posi', x)
      .attr('data-tag', vtags[vaultDataTag][0]);
    //.html(productData.title);

    var $newProductImages = $('<div />').addClass('gu-vault__product-images');
    var $newProductSlider = $('<div />').addClass('gu-vault__product-image-slider');

    for (y in productData.images) { 
      var img = productData.images[y];
      var imgSrc = img.src.replace('.jpg', '_1200x1200_crop_center.jpg').replace('.png', '_1200x1200_crop_center.png');

      if(y > 0) {
        var $lazyImg = $('<img />').prop('src', window.vault_loader).attr('data-flickity-lazyload',imgSrc).addClass('gu-vault__product-image');
        $newProductSlider.append($lazyImg);
      } else {
        var $newImg = $('<img />').prop('src', imgSrc).addClass('gu-vault__product-image');
        $newProductImages.append($newImg);
      }
    }
    $newProductImages.append($newProductSlider);
    

    var $productQaBtnIcon = $('<span />').addClass('gu-collection__item-button-icon');
    var $productQaBtnIconPart = $('<span />').addClass('gu-collection__item-button-icon-part');

    $productQaBtnIcon.append($productQaBtnIconPart).append($productQaBtnIconPart.clone());
    
    var $productQa = $('<button />')
          .addClass('gu-collection__item-button gu-collection__item-button--add')
          .attr('data-collection', collectionID)
          .attr('data-product', productData.id)
          .attr('data-index', x)
          .on('click', function(){ 
            var $this = $(this);
            var collection = parseInt($this.data('collection'));
            var product = parseInt($this.data('product'));
            var index = parseInt($this.data('index'));
            // console.log(collection);
            // console.log(product);
            // console.log(index);
            // console.log(window.quickadd[collection][index].images)
            
            window.quickAdd(collection, product, index);
          })

    var $newProductTitle = $('<div />').addClass('gu-vault__product-title').html(productData.title);
    var $newProductSubTitle = $('<span />').addClass('gu-vault__product-sub-title').html(vtags[vaultDataTag][1]);
    $newProductTitle.append($newProductSubTitle);

    $newProduct
      .append($newProductImages)
      .append($productQa)
      .append($newProductTitle) 
      // .append($productTag.clone().html(vtags[x][1]).addClass('vault-tag--'+vtags[x][0]))

    $vaultCollectionItems.append($newProduct);
    
  }

  $('.gu-vault__product').on('click', function(ev) {
    var posi = $(this).attr('data-posi');
    var $targ = $(ev.target).closest('.flickity-button');
    console.log($targ.length);
    if(!$targ.length){
      window.scrollTo(0,1);
      $body.addClass('gu-invert').addClass('vault-product-open');
      showProduct(posi);
    }
  });

  $vaultCollection.addClass('show-collection');
  setTimeout(fadeEmIn, 2400);
}

var currFlickity = false;
var prevFlickity = false;

function fadeEmIn() {
  console.log('fading in');
  $('.gu-vault__product').each(function(index) {
    $(this).delay(300*index).animate({'opacity': 1},300);
  });

  var galleryElems = document.querySelectorAll('.gu-vault__product-image-slider');
  for ( var i=0, len = galleryElems.length; i < len; i++ ) {
    var galleryElem = galleryElems[i];
    new Flickity( galleryElem, {
      cellAlign: 'center',
      lazyLoad: 2, 
      wrapAround: true, 
      prevNextButtons: true, 
      contain: true,
      pauseAutoPlayOnHover: false,
      cellSelector: 'img',
      draggable: false
    });
  }
   
  /*
  $('.gu-vault__product').on('mouseover touchstart touchmove', function(){
    var $this = $(this);
    var posi = $this.data('posi');
    var $slider = $this.find('.gu-vault__product-image-slider');

    // console.log(`posi: ${posi}`);
    // console.log(`currFlickity: ${currFlickity}`);
    // console.log(`prevFlickity: ${prevFlickity}`);

    if(currFlickity != posi) {
      prevFlickity = currFlickity; 
      currFlickity = posi;
      /* 
      $slider.flickity({
        // options
        cellAlign: 'center',
        lazyLoad: 2,
        wrapAround: true,
        prevNextButtons: true,
        contain: true,
        pauseAutoPlayOnHover: false,
        cellSelector: 'img',
        draggable: false
      });

      

    } else {
      if(prevFlickity !== false) {
        window['sliderFlickity_'+prevFlickity].destroy();
        // $('.gu-vault__product[data-posi="'+prevFlickity+'"]').find('.gu-vault__product-image-slider').flickity('destroy');
        prevFlickity = false;
      }
    }
  })

  */
}

function hideGate() {
  setTimeout(function(){
    $vaultGate.removeClass('gu-vault-gate--hide');
  }, 1200);
}

function removeSuccess() {
  $('.gu-vault-gate__actions').remove();
}

function closeSuccess() {
  allowed = false;
  // // console.log('closing');
  $('.gu-vault-gate__actions').animate({'height': '0' }, 500, removeSuccess);
}

function invalidCode() {
  $inputs.blur();
  $vaultGate.removeClass('code-accepted');
  $vaultGate.removeClass('code-failed');
  $errorMessage.find('span').html('');
  clearInputVals();
  $vaultGate.removeClass('gu-vault-gate--show').addClass('gu-vault-gate--hide');
  closeSuccess();

  hideGate();
}

function startTimer(current, expires) {
  timerEnabled = true;
  var countDownDate = new Date(getJsTimestamp(expires)).getTime();
  // console.log('countDownDate');
  // console.log(countDownDate);
  var nowLog = new Date().getTime();
  // console.log(nowLog);
  var $counter = $('<div />').addClass('gu-vault-collection__timer');
  var $counterTime = $('<div />').addClass('gu-vault-collection__timer-time').html('00:00');
  var $counterText = $('<div />').addClass('gu-vault-collection__timer-text').html('remaining');
  $counter.append($counterTime).append($counterText);
  $body.append($counter.fadeOut(0));

  timeit();
  var vaulttimer = setInterval(timeit, 1000);
  setTimeout(function(){
    $counter.fadeIn(500);
  }, 1000);

  function timeit() {
    // console.log('count');
    var now = new Date().getTime();
    var timeleft = countDownDate - now;
    if(timeleft > 0) {
      var timer_days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      var timer_hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var timer_minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      var timer_seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

      $counterTime.html((timer_hours + ':' + ('0' + (timer_minutes)).slice(-2)) + ':' + ('0' + timer_seconds).slice(-2));
    } else {
      clearInterval(vaulttimer);
      $counter.remove();
      timerEnabled = false;
      timerExpired();
    }
  }
    
}

function timerExpired() {
  allowed = false;
  disabled = false;
  $("html, body").animate({ scrollTop: 0 }, 500);
  collectionItems = [];
  clearInputVals();
  $vaultGate.addClass('gu-vault-gate--show');
  $('.show-collection').removeClass('show-collection');
	$('.gu-vault-exp').show();
  setTimeout(dePopulate, 1200);
}

function dePopulate() {
  $('.gu-vault-collection__items').html('');
  window.location.reload();
}

function getJsTimestamp(timestamp) {
  return new Date(timestamp * 1000);
}
function getPHPTimestamp(timestamp) {
  return Math.round(timestamp / 1000);
}
function addTimetoDate(date, minutes) {
  return new Date(date.getTime() + minutes*60000);
}

function allowEntry(phpData) {
  /*
  phpData.status = 'SUCCESS' / 'ACTIVE'
  phpData.message = string,
  phpData.usedTime = object,
  phpData.usedTimeStamp = int,
  phpData.currentTime = object,
  phpData.currentTimestamp = int
  */
  disableInputs();

  if(!allowed) {
    allowed = true;
    var $accessActions = $('<div />').addClass('gu-vault-gate__actions');
    var $accessMessage = $('<p />').addClass('gu-vault-gate__action-message').html('Your access timer will start once you enter');
    var $accessNowButton = $('<button />').attr('id', 'vaultEnter').addClass('gu-vault-gate__action gu-vault-gate__action--enter').html('ENTER VAULT');
    var $accessLaterButton = $('<button />').attr('id', 'vaultLater').addClass('gu-vault-gate__action gu-vault-gate__action--later').html('Use later');
    $accessActions.append($accessMessage).append($accessNowButton).append($accessLaterButton).css({'height': 0 });
    $accessActions.insertAfter($accessForm);
    $accessActions.animate({'height': '4.5rem' }, 300);

    $accessNowButton.click(function(e){
      useCode(true, phpData);
    });

    $accessLaterButton.click(function(e){
      invalidCode();
    });
  }
}

function useCode(newCode, data) {
  document.activeElement.blur();
  // PARAM codeUsed 
  // - '' if new code
  // - obj if used code

  // determines whether the database 'used' record is updated

  // console.log('useCode fn'); 
  // console.log('- - - - - - - - - - - - - - - - - - - - - - - - - ');
  // console.log(data);

  var vaultKey = '';
  var expires = (newCode) ? 0 : parseInt(data.expiresTimestamp);

  $inputs.each(function(index){
    var $this = $(this);
    var thisVal = $this.val();
    vaultKey += thisVal;
  });

  var url = 'https://vault.geedupclothing.com/vault2/code/use_code';
  var formData =  {
    'vault_code' : vaultKey,
    'store' : 'geedupstore.myshopify.com',
    'used' : false,
    'updateRecord': newCode,
    'expires' : expires
  };

  $.ajax({
    type: "POST",
    url: url,
    crossDomain: true,
    data: JSON.parse(JSON.stringify(formData)),
    success: function(data)
    {
      // var dataJSON = JSON.parse(data);
	  var dataJSON = data;

      if(dataJSON.products.length) {
        populateVault(dataJSON.products);
        if(!timerEnabled) {
          startTimer(dataJSON.currentTimeStamp, dataJSON.expiresTimeStamp);
        }
      }
    },
    error: function (xhr, status) {
      console.log(status);
    }
  });
}

function disableInputs() {
  disabled = true;
  $inputs.each(function(index){
    $(this).prop('readonly', true);
  });
}

function enableInputs() {
  disabled = false;
  $inputs.each(function(index){
    $(this).prop('readonly', false);
  });
}

function vipAccess(id, name) {
  var url = 'https://vault.geedupclothing.com/vault2/code/vip_access';
  var formData =  {
    'user' : id,
    'name' : name,
    'store' : 'geedupstore.myshopify.com'
  };

  $.ajax({
    type: "POST",
    url: url,
    crossDomain: true,
    data: JSON.parse(JSON.stringify(formData)),
    success: function(data)
    { 
      // var dataJSON = JSON.parse(data);
      var dataJSON = data;
      $vaultGate.addClass('code-accepted');
      populateVault(dataJSON.products);
    },
    error: function (xhr, status) {
      $vaultGate.addClass('code-failed');
      $errorMessage.find('span').html('Unknown Error');
      setTimeout(invalidCode, 2000);
      enableInputs();
    }
  });
}
function checkCode(code) {
    disableInputs();
    var url = 'https://vault.geedupclothing.com/vault2/code/validate_code';
    var formData =  {
      'vault_code' : code,
      'store' : 'geedupstore.myshopify.com'
    };

    $.ajax({
      type: "POST",
      url: url,
      crossDomain: true,
      data: JSON.parse(JSON.stringify(formData)),
      success: function(data)
      { 
      // var dataJSON = JSON.parse(data);
      var dataJSON = data;
        
        if(dataJSON.status == 'SUCCESS') 
        {
          $vaultGate.addClass('code-accepted');
          allowEntry(dataJSON);
        } 
        else if (dataJSON.status == 'ACTIVE') 
        {
          $vaultGate.addClass('code-accepted');
          useCode(false, dataJSON);
        }
        else if(dataJSON.status == 'EXPIRED') 
        {
          $vaultGate.addClass('code-failed');
          $errorMessage.find('span').html(dataJSON.message);
          setTimeout(invalidCode, 2000);
        }
        else  
        {
          $vaultGate.addClass('code-failed');
          $errorMessage.find('span').html(dataJSON.message);
          setTimeout(invalidCode, 2000);
        }
        
        
      },
      error: function (xhr, status) {
        $vaultGate.addClass('code-failed');
        $errorMessage.find('span').html('Unknown Error');
        setTimeout(invalidCode, 2000);
        enableInputs();
      }
    });
}

function checkInputVals() {
  $vaultGate.removeClass('code-accepted');
  $vaultGate.removeClass('code-failed');

  var vaultKey = '';

  $inputs.each(function(index){
    var $this = $(this);
    var thisVal = $this.val();
    vaultKey += thisVal;

    if(thisVal === '') {
      $this.removeClass('added');
    } else {
      $this.addClass('added');
    }
  });

  if(vaultKey.length === 10) {
    checkCode(vaultKey);
  } else {
    closeSuccess();
  }
}

function clearInputVals() {
  $vaultGate.removeClass('code-accepted');
  $vaultGate.removeClass('code-failed');

  $inputs.each(function(index){
    $(this).val('').removeClass('added');
  });
}
function fillVIPInputs(data) {
  $inputs.each(function(index){
    $(this).val(data[index]);
  });
}

function fillInputs(data) {
  $inputs.each(function(index){
    $(this).val(data[index]);
  });
  checkInputVals()
}

function timeConverter(UNIX_timestamp){
  var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
  return time;
}

  var showing = false;
  window.reduceVaultQuantities = function(items) {
    // console.log('reduceVaultQuantities');
    $.post('/cart/update.js', {
      updates: items
    }, function(data){
      // console.log('reducing found items');
      console.log(data);
      window.refreshCart(); 
    },'json');
  }

  window.checkVaultQuantities = function(){
    // console.log('checkVaultQuantities');

    jQuery.getJSON('/cart.js', function(cart) {
      var items = cart.items;
      var item_count = cart.item_count; 
      var found = 0;
      var toReduce = new Object();
      var ids = new Object();

      if(items.length){
        for (i in items) {   
          var item = items[i];  
          if(item.sku.includes("V-")) { 
            var itemQty = item.quantity;
            var duplicate = (item.product_id in ids);
            if(duplicate) {
              ids[item.product_id] = ids[item.product_id] + item.quantity;
            } else {
              ids[item.product_id] = item.quantity;
            }

            if(duplicate) { 
              var otherSizeQty = ids[item.product_id]; 
              console.log('otherSizeQty: '+ otherSizeQty);
               
              if(otherSizeQty > 2) {
                toReduce[item.id] = 0; 
              } else {
                toReduce[item.id] = 1;
              }
              found++;
            } else if(itemQty > 2) {
              found++;
              toReduce[item.id] = 2;

            }
          } 
        }
      } 

      if(found > 0) {
        window.reduceVaultQuantities(toReduce);
      }
    }); 
    /*

    var size = Object.keys(toRemove).length;

    if(size > 0) { 

    }

    */
  }

function showProduct(posi) {
  if(!showing) {
    showing = true;
    window.selectedVaultVariant = false;
    window.selectedVaultProduct = false;

    var qty = 1;
    var maxQty = 2;

    var product = collectionItems[posi];
    // console.log('showing product');
    console.log(product);
  /* 
    $KiwiSizingChart = $('#KiwiSizingChart')
      .attr({
        'data-collections': '261737381967',
        'data-tags': product.tags,
        'data-product': product.id,
        'data-vendor': product.vendor,
        'data-product-name': product.title,
        'data-product-type': product.type
      })

      */

    var $vaultFullProductModal = $('<div />').addClass('gu-vault-full-product-modal');
    var $vaultFullProduct = $('<div />').addClass('gu-vault-full-product');
    var $vaultFullProductContainer = $('<div />').addClass('gu-vault-full-product__container');
    var $vaultFullProductImages = $('<div />').addClass('gu-vault-full-product__images');
    var $vaultFullProductData = $('<div />').addClass('gu-vault-full-product__data');
 
    // CLOSE BTN
    var $vaultFullProductClose = $('<button />').addClass('gu-vault-full-product__close').html('<span></span><span></span>');

    // DATA
    var $vaultFullProductDataSticky = $('<div />').addClass('gu-vault-full-product__data-sticky');

    // TITLE
    var $vaultFullProductTitle = $('<h1 />').addClass('gu-product__title').html(product.title);

    // META
    var $vaultFullProductMeta = $('<div />').addClass('gu-product__meta');
    var $vaultFullProductCollection = $('<div />').addClass('gu-product__collection').html('Vault');
    var $vaultFullProductPrice = $('<div />').addClass('gu-product__price').html('$' + product.variants[0].price);
    $vaultFullProductMeta.append($vaultFullProductCollection).append($vaultFullProductPrice);

    // VARIANTS
    var $vaultFullProductVariants = $('<div />').addClass('gu-product__variants');

    for (x in product.variants) {
      var variant = product.variants[x];

      var $variantButton = $('<button />')
        .addClass('gu-product__variant')
        .data('id',variant.id )
        .html(variant.title)
        .click(function(){
          var $this = $(this);
          $('.gu-product__variants').find('.v-selected').removeClass('v-selected');
          $('.c-disabled').removeClass('c-disabled');
          $this.addClass('v-selected');
          window.selectedVaultVariant = $this.data('id');
          window.selectedVaultProduct = {
            title: product.title,
            variant: variant.title,
            price: product.price,
            image: product.images[1]
          };
        })
      if(variant.inventory_quantity <= 0) {
        $variantButton.addClass('v-disabled'); 
      }
      $vaultFullProductVariants.append($variantButton); 
    }

    // QUANTITY
    var $vaultFullProductQuantity = $('<div />').addClass('gu-product__quantity');
    var $vaultFullProductQuantityMinus = $('<button />').addClass('gu-product__quantity-button gu-product__quantity-button--minus q-disabled').html('-');
    var $vaultFullProductQuantityQty = $('<div />').addClass('gu-product__quantity-value').html(qty);
    var $vaultFullProductQuantityPlus = $('<button />').addClass('gu-product__quantity-button gu-product__quantity-button--plus').html('+');
    $vaultFullProductQuantity
      .append($vaultFullProductQuantityMinus)
      .append($vaultFullProductQuantityQty)
      .append($vaultFullProductQuantityPlus)

    function updateQty() {
      $vaultFullProductQuantityQty.html(qty);
      if(qty > 1 && qty < maxQty ) {
        $vaultFullProductQuantityMinus.removeClass('q-disabled');
        $vaultFullProductQuantityPlus.removeClass('q-disabled');
      } 
  
      if(qty == maxQty ) {
        $vaultFullProductQuantityPlus.addClass('q-disabled');
        $vaultFullProductQuantityMinus.removeClass('q-disabled'); 
      } 
  
      if(qty == 1 ) {
        $vaultFullProductQuantityMinus.addClass('q-disabled');
        $vaultFullProductQuantityPlus.removeClass('q-disabled'); 
      } 
    }
    
    $vaultFullProductQuantityMinus.click(function(){
      $vaultFullProductQuantityMinus.blur();
        if(qty > 1) {
          qty--;
          updateQty();
        }
      });
    
      $vaultFullProductQuantityPlus.click(function(){
        $vaultFullProductQuantityPlus.blur();
        if(qty < maxQty) {
          qty++;
          updateQty();
        }
      });



    // ACTION BUTTON
    var $vaultFullProductAction = $('<button />')
      .addClass('gu-product__action c-disabled')
      .html('<span class="gu-product__action--enabled">Add to cart</span><span class="gu-product__action--disabled">Select Size</span>')
      .click(function(){
        var $this = $(this);
        $this.addClass('qa-loading');
  
        if(window.selectedVaultVariant) {
          jQuery.post('/cart/add.js', {
            quantity: qty,
            id: window.selectedVaultVariant 
          }, function(data) {
            // window.checkSuggest(data.product_id);
            window.checkPromoOnAdd();
            window.setCartCount(1, window.selectedVaultVariant, window.selectedVaultProduct);
            closeVaultProduct();
            window.refreshCart(); 
            window.openCart(); 
            window.checkVaultQuantities();
          },'json')
          .fail(function() {
            alert( "Sorry, an error occurred" );
            closeVaultProduct();
            window.refreshCart(); 
          }); 
        }
      });; 

    // VIDEO 
    var $vaultFullProductVideo = '';  

    /*
    var $vaultFullProductVideo = $('<video />').addClass('gu-vault-full-product__video')
      .attr('playsinline', true)
      .attr('autoplay', true)
      .attr('muted', true)
      .attr('loop', true)

    var $vaultFullProductVideoSource = $('<source />').addClass('gu-vault-full-product__video')
      .attr('src', window.vault_video_url)
      .attr('type', 'video/mp4');

    $vaultFullProductVideo.append($vaultFullProductVideoSource)
*/
    /*
     <video playsinline autoplay muted loop poster="" id="vaultVid">
    <source src="{{ 'vault.mp4' | asset_url }}" type="video/mp4">
  </video>

  */

    // INFO 
    var $vaultFullProductInfo = $('<div />').addClass('gu-vault-full-product__info').html(product.body_html);

    var $vaultAccordion = $('<dl />').addClass('gu-vault-product__accordion');
    var $vaultAccordionTerm = $('<dt />').addClass('gu-vault-product__accordion-term');
    var $vaultAccordionData = $('<dd />').addClass('gu-vault-product__accordion-data');

    var $vaultAccordionInfoTitle = $vaultAccordionTerm.clone().html('Garment Info');
    var $vaultAccordionInfoContent = $vaultAccordionData.clone().addClass('gu-vault-product__description').html('Garment Info').html(product.body_html.replace('<b>Garment Info:</b>', ''));
      var shippingInfo = ` 
        <strong>DELIVERY TIMES</strong>
        <hr>
        <p>
          <strong>Australia Standard</strong> <span class="nowrap">(Authority to leave)</span><br>
          $14.95 - 3-5 Business Days
        </p>
        <p>
          <strong>Australia Standard</strong> <span class="nowrap">(Signature required)</span><br>
          $15.95 - 3-5 Business Days
        </p>
        <p>
          <strong>Australia Express</strong> <span class="nowrap">(Order before 2pm)</span><br>
          $21.95 - *Next Day Delivery
        </p>
        <p>
          <strong>International</strong><br>
          $22.95 - 7-14 Business Days
        </p>
        <p class="gu-vault-product__terms"><small>
          * During high frequency traffic periods (delivery and sale periods) please allow up to three business days for processing on all deliveries including the express delivery options, but please note the express option is always priority.
        </small></p>
        <p class="gu-vault-product__terms"><small>
          * Shipping time may vary according to Australia Post and Courier time frames and zones  these times do not include order processing time.
        </small></p>
        <p class="gu-vault-product__terms"><small>
          * Shipping times will vary dependant on your delivery location, it takes less time to delivery to Metro than to rural addresses, please make sure you factor these added times in when placing your order.
        </small></p>
        <p class="gu-vault-product__terms"><small>
          * Express orders placed weekdays before 2pm AEST will leave our warehouse on the same day. Orders placed outside of these times will leave the next business day. *Delivery time will then be based on Australia Post
        </small></p>
        <a class="gu-vault-product__link" href="/pages/shipping">More about shipping</a>
      </dd>`
    ;

    var $vaultAccordionShippingTitle = $vaultAccordionTerm.clone().html('Shipping Info');
    var $vaultAccordionShippingContent = $vaultAccordionData.clone().html(shippingInfo);

    $vaultAccordion
      .append($vaultAccordionInfoTitle)
      .append($vaultAccordionInfoContent)
      .append($vaultAccordionShippingTitle)
      .append($vaultAccordionShippingContent);

    $vaultFullProductDataSticky
      .append($vaultFullProductTitle)
      .append($vaultFullProductMeta)
      .append($vaultFullProductVariants)
      .append($vaultFullProductQuantity)
      .append($vaultFullProductAction)
      .append($vaultFullProductVideo)
      .append($vaultAccordion)

    $vaultFullProductData
      .append($vaultFullProductDataSticky);


    
    // IMAGES
    var $vaultFullProductImageSlider = $('<div />').addClass('gu-vault-full-product__slider');

    for (y in product.images) { 
      var img = product.images[y];
      var imgSrc = img.src.replace('.jpg', '_640x800_crop_center.jpg').replace('.png', '_640x800_crop_center.png');

      var $lazyImg = $('<img />').prop('src', window.default_img).attr('data-flickity-lazyload', imgSrc).addClass('gu-vault-full-product__image');
      $vaultFullProductImageSlider.append($lazyImg);

    }

    $vaultFullProductImages.append($vaultFullProductImageSlider);
    
    $vaultFullProductContainer
      .append($vaultFullProductImages)
      .append($vaultFullProductData);

    $vaultFullProduct
      .append($vaultFullProductContainer)
        .append($vaultFullProductClose);

    $vaultFullProductModal
      .append($vaultFullProduct);

    $body
      .append($vaultFullProductModal);
    
    setTimeout(function() {
      $vaultFullProductModal.addClass('animate-product');

      /*
      $vaultFullProductImageSlider.flickity({
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false, 
        lazyLoad: 4,
        pageDots: false 
      }); 
      */

      window.vaultFlickity = new Flickity( '.gu-vault-full-product__slider', {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false, 
        lazyLoad: 4,
        pageDots: false 
      });


      $('.gu-vault-product__accordion').find('dd').slideUp(0);

      $('.gu-vault-product__accordion').on('click', 'dt:not(.active)', function(){
        // console.log('click');
        $('.gu-vault-product__accordion').find('dt.active').removeClass('active');
        $('.gu-vault-product__accordion').find('dd').slideUp();
        $(this).addClass('active').next('dd').slideDown();
      });

      $('.gu-vault-product__accordion').on('click', 'dt.active', function(){
        // console.log('click');
        $(this).removeClass('active').next('dd').slideUp();
      });

    }, 100);

    $vaultFullProductClose.on('click', function() {
      window.checkInvert($logo, $invert);
      closeVaultProduct();
    })
  }

  function closeVaultProduct() {
    $vaultFullProductModal.removeClass('animate-product');
    $body.removeClass('vault-product-open');

  
    setTimeout(function() {
      $vaultFullProductModal.remove();
      showing = false;
    }, 1000);
  }
}



  } catch(e) { console.error(e); }
})();
})();
